<template>
<div>
  <section class="sh-contentWrapper">
    <section class="sh-recommend__top">
        <div class="sh-recommend__topTitle">
            <h1>
            {{ message_h1 }}
            </h1>
            <img src="/static/img/secoundhalf/person_christinederico.png" alt="">
        </div>
    </section>
  </section>


  <h3 class="">2018年の下半期占いのご紹介</h3>
  <section class="sh-recommend__body">
    <div class="sh-recommend__header">
      <div><img src="https://placehold.jp/150x150.png" alt=""></div>
      <div>見える占い体験してみませんか？<br>パシンペロンはやぶさ</div>
    </div>
    <ul>
      <li><a href="#">
        <strong>2018年下半期総合運</strong>
        <span class="sh-recommend__text">この下半期、あなたに一体何が起こる？</span>
        <span class="sh-recommend__price">price</span></a></li>
      <li><a href="#">
        <strong>2018年下半期総合運</strong>
        <span class="sh-recommend__text">この下半期、あなたに一体何が起こる？</span>
        <span class="sh-recommend__price">price</span></a></li>
      <li><a href="#">
        <strong>2018年下半期総合運</strong>
        <span class="sh-recommend__text">この下半期、あなたに一体何が起こる？</span>
        <span class="sh-recommend__price">price</span></a></li>
    </ul>
  </section>
</div>
</template>

<script>
export default {
  data: function() {
    return {
      message_h1: 'トランプ大統領、支持率アップの上半期！その裏には意外なアレがあった！？'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/SecondRecommend.vue